// extracted by mini-css-extract-plugin
export var blue = "_2a-f";
export var brand = "_2a-b";
export var darkGrey = "_2a-e";
export var disabled = "_2a-4";
export var disabledSubtle = "_2a-5";
export var error = "_2a-6";
export var green = "_2a-g";
export var grey = "_2a-d";
export var icon = "_2a-0";
export var inherit = "_2a-a";
export var lightGrey = "_2a-c";
export var orange = "_2a-i";
export var pink = "_2a-k";
export var primary = "_2a-1";
export var purple = "_2a-l";
export var red = "_2a-j";
export var secondary = "_2a-2";
export var success = "_2a-9";
export var tertiary = "_2a-3";
export var warning = "_2a-7";
export var warningSecondary = "_2a-8";
export var white = "_2a-m";
export var yellow = "_2a-h";